import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { Route as RouteType } from '../Routing/types';
import { AllSettingsProvider } from './context/AllSettingsContext';

interface AllSettingsPageProps {
  descendantRoutes: RouteType[];
}

const AllSettingsPage: React.FC<AllSettingsPageProps> = ({ descendantRoutes }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Automatycznie przekieruj na pierwszy krok - biometric-settings
    navigate('/all-settings/biometric-settings/sex', { replace: true });
  }, [navigate]);

  return (
    <AllSettingsProvider>
      <Routes>
        {descendantRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
      </Routes>
    </AllSettingsProvider>
  );
};

export default AllSettingsPage;
